import React, { useCallback } from "react";
import { useFormik } from "formik";
import { Button, Error, Input, Label } from "../../Components";
import { differenceSchema } from "../../Schema/BadlaSchema";
import { postAxios } from "../../Services/commonService";

const Difference = ({ rowData = {}, handleShowHide }) => {
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
  } = useFormik({
    initialValues: {
      comexDifference: rowData?.comexDiffAmt || 0,
      mcxDifference: rowData?.mcxDiffAmt || 0,
      dgcxDifference: rowData?.dgcxDiffAmt || 0,
    },
    enableReinitialize: true,
    validationSchema: differenceSchema,
    onSubmit: (values) => {
      handleFormSubmit({ values });
    },
  });

  const handleFormSubmit = useCallback(async ({ values }) => {
    const res = await postAxios({
      url: "/badlaOrder/updatedifference",
      payload: {
        mcxDiffAmt: values?.mcxDifference,
        comexDiffAmt: values?.comexDifference,
        dgcxDiffAmt: values?.dgcxDifference,
        badlRefId: rowData?.badlRefId,
      },
    });

    handleShowHide();
  }, []);

  return (
    <form className="form-order" onSubmit={handleSubmit}>
      <div className="row  m-0 p-0 align-items-end">
        <div className="col-lg-4 col-sm-6 col-6 m-0 p-1">
          <div className="form-group ">
            <Label className="lead_text">Comex Difference</Label>
            <Input
              type="text"
              placeholder="Enter Amount"
              className="form-control"
              name="comexDifference"
              onChange={handleChange}
              onblur={handleBlur}
              value={values.comexDifference}
              id="comexDifference"
              autoFocus={true}
            />
            {errors?.comexDifference && touched?.comexDifference && (
              <Error>{errors?.comexDifference}</Error>
            )}
          </div>
        </div>
        <div className="col-lg-4 col-sm-6 col-6 m-0 p-1">
          <div className="form-group ">
            <Label className="lead_text">Mcx Difference</Label>
            <Input
              type="text"
              placeholder="Enter Amount"
              className="form-control"
              name="mcxDifference"
              onChange={handleChange}
              onblur={handleBlur}
              value={values.mcxDifference}
              id="mcxDifference"
            />
            {errors?.mcxDifference && touched?.mcxDifference && (
              <Error>{errors?.mcxDifference}</Error>
            )}
          </div>
        </div>
        <div className="col-lg-4 col-sm-6 col-6 m-0 p-1">
          <div className="form-group ">
            <Label className="lead_text">Comex Difference</Label>
            <Input
              type="text"
              placeholder="Enter Amount"
              className="form-control"
              name="dgcxDifference"
              onChange={handleChange}
              onblur={handleBlur}
              value={values.dgcxDifference}
              id="dgcxDifference"
            />
            {errors?.dgcxDifference && touched?.dgcxDifference && (
              <Error>{errors?.dgcxDifference}</Error>
            )}
          </div>
        </div>
      </div>

      <Button type="submit" id="form-submit-btn" hidden={true}></Button>
    </form>
  );
};

export default Difference;
